const DonationTrackerTypes = Object.freeze({
  // Direct Stripe donations
  Stripe: 'stripe',

  StripeContribution: 'stripeContribution',

  // Stripe donations with company matching
  StripeCompanyMatch: 'stripeCompanyMatch', // automatic processing
  StripeCompanyMatchToUnclaimed: 'stripeCompanyMatchToUnclaimed', // NPO unclaimed, not enabled for Stripe

  // External donations
  External: 'external',
  ExternalContribution: 'externalContribution',

  // External donations with company matching
  ExternalCompanyMatch: 'externalCompanyMatch', // processed externally by company admin
  ExternalCompanyMatchToUnclaimed: 'externalCompanyMatchToUnclaimed', // unclaimed external donation

  // Gift of Giving donations via Stripe
  GiftOfGivingByStripe: 'giftOfGivingByStripe',
  GiftOfGivingByStripeToUnclaimed: 'giftOfGivingByStripeToUnclaimed', // unclaimed NPO not enabled for Stripe

  // Gift of Giving donations via external sources
  GiftOfGivingByExternal: 'giftOfGivingByExternal', // typically to specific regions (e.g., India, Mexico)
  GiftOfGivingByExternalToUnclaimed: 'giftOfGivingByExternalToUnclaimed', // unclaimed, external to specific regions

  NoTrackerDonation: 'noTrackerDonation',
  NoTrackerContribution: 'noTrackerContribution',
});

const DonationTrackerEventStatus = Object.freeze({
  0: 'failed',
  1: 'completed',
  2: 'pending',
  3: 'in_progress',
});

const DonationTrackerEventLabels = {
  [DonationTrackerTypes.Stripe]: {
    labels: [
      { id: 1, label: 'Donation made to [Nonprofit Name]' },
      { id: 2, label: "Donation deposited to the nonprofit's Stripe Wallet" },
      // { id: 3, label: "Donation deposited to nonprofit's Bank Account" },
    ],
  },

  [DonationTrackerTypes.StripeContribution]: {
    labels: [
      { id: 1, label: 'Contribution made to Fundraising Organization' },
      {
        id: 2,
        label:
          "Contribution deposited to the Fundraising Organization's Stripe Wallet",
      },
      // { id: 3, label: "Donation deposited to nonprofit's Bank Account" },
    ],
  },
  [DonationTrackerTypes.StripeCompanyMatch]: {
    labels: [{ id: 1, label: 'Donation Match processed by [Company Name]' }],
  },
  [DonationTrackerTypes.StripeCompanyMatchToUnclaimed]: {
    labels: [
      {
        id: 1,
        label:
          'Nonprofit claimed their profile on Neki and ready to receive donation match',
      },
      { id: 2, label: 'Donation Match processed by [Company Name]' },
    ],
  },
  [DonationTrackerTypes.External]: {
    labels: [
      { id: 1, label: 'Donation made to [Nonprofit Name]' },
      { id: 2, label: 'Confirmed and uploaded the external donation receipt' },
      { id: 3, label: "Confirmed donation to nonprofit's Bank Account" },
    ],
  },
  [DonationTrackerTypes.ExternalContribution]: {
    labels: [
      { id: 1, label: 'Contribution made to Beneficiary' },
      {
        id: 2,
        label: 'Confirmed and uploaded the external contribution receipt',
      },
      { id: 3, label: "Confirmed contribution to Beneficiary's Bank Account" },
    ],
  },
  [DonationTrackerTypes.ExternalCompanyMatch]: {
    labels: [
      { id: 1, label: 'Donation Match made to [Nonprofit Name]' },
      {
        id: 2,
        label: 'Confirmed and uploaded the external donation match receipt',
      },
      { id: 3, label: 'Donation Match processed by [Company Name]' },
    ],
  },
  [DonationTrackerTypes.ExternalCompanyMatchToUnclaimed]: {
    labels: [
      { id: 1, label: 'Donation Match made to [Nonprofit Name]' },
      {
        id: 2,
        label: 'Confirmed and uploaded the external donation match receipt',
      },
      {
        id: 3,
        label:
          'Nonprofit claimed their profile on Neki and ready to receive donation match',
      },
      { id: 4, label: 'Donation Match processed by [Company Name]' },
    ],
  },
  [DonationTrackerTypes.GiftOfGivingByStripe]: {
    labels: [
      { id: 1, label: 'Gift of Giving allocated to nonprofit' },
      { id: 2, label: '[Company Name] donated to nonprofit' },
      { id: 3, label: "Donation deposited to nonprofit's Stripe Wallet" },
      // { id: 4, label: "Donation deposited to nonprofit's Bank Account" },
    ],
  },
  [DonationTrackerTypes.GiftOfGivingByStripeToUnclaimed]: {
    labels: [
      { id: 1, label: 'Gift of Giving allocated to nonprofit' },
      {
        id: 2,
        label:
          'Nonprofit has set up their account on Stripe and are ready to receive Gift of Giving donation',
      },
      { id: 3, label: '[Company Name] donated to nonprofit' },
      { id: 4, label: "Donation deposited to nonprofit's Stripe Wallet" },
      // { id: 5, label: "Donation deposited to nonprofit's Bank Account" },
    ],
  },
  [DonationTrackerTypes.GiftOfGivingByExternal]: {
    labels: [
      // { id: 1, label: 'Donation made to [Nonprofit Name]' },
      // { id: 2, label: 'Donor confirmed and uploaded the external donation receipt' },
      // { id: 3, label: 'Gift of Giving donation processed by [Company Name]' },
      { id: 1, label: 'Gift of Giving allocated to nonprofit' },
      { id: 2, label: '[Company Name] donated to nonprofit' },
      { id: 3, label: 'Donation confirmed by [Company Name]' },
    ],
  },
  // [DonationTrackerTypes.GiftOfGivingByExternalToUnclaimed]: {
  //   labels: [
  //     // { id: 1, label: 'Donation made to [Nonprofit Name]' },
  //     // { id: 2, label: 'Donor confirmed and uploaded the external donation receipt' },
  //     // { id: 3, label: 'Nonprofit claimed their profile on Neki and ready to receive Gift of Giving donation' },
  //     // { id: 4, label: 'Gift of Giving donation processed by [Company Name]' },
  //     { id: 1, label: 'Gift of Giving allocated to nonprofit' },
  //     { id: 2, label: '[Company Name] donated to nonprofit' },
  //     { id: 3, label: 'Donation confirmed by [Company Name]' },
  //   ],
  // },

  [DonationTrackerTypes.NoTrackerDonation]: {
    labels: [{ id: 1, label: 'Donation made to [Nonprofit Name]' }],
  },
  [DonationTrackerTypes.NoTrackerContribution]: {
    labels: [{ id: 1, label: 'Contribution made to Fundraising Organization' }],
  },
};

export {
  DonationTrackerTypes,
  DonationTrackerEventStatus,
  DonationTrackerEventLabels,
};
